const setLocalUserInfo = (userInfo: any) => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

const getUserInfo = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

const setLocalTheme = (theme: string) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  const theme = localStorage.getItem("theme");
  return theme ?? "light";
};

const setLocalLanguage = (language: string) => {
  localStorage.setItem("language", language);
};

const getLanguage = () => {
  const language = localStorage.getItem("language");
  return language ?? "en";
};

const setLocalTenantId = (tenantId: string) => {
  localStorage.setItem("tenantId", tenantId);
};

const getEnvTenantId = () =>
  (import.meta.env.VITE_X_TENANTID ?? "")
    .toString()
    .replace(/^"|"$/g, "")
    .trim();

const getTenantId = () => {
  const tenantId = localStorage.getItem("tenantId");
  if (tenantId) {
    return tenantId;
  }
  const envTenantId = getEnvTenantId();
  return envTenantId ?? null;
};
const setLocalAccessToken = (accessToken: string) => {
  localStorage.setItem("accessToken", accessToken);
};

const getAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken ?? null;
};

const setLocalRefreshToken = (refreshToken: string) => {
  localStorage.setItem("refreshToken", refreshToken);
};

const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return refreshToken ?? null;
};

const clearLocalStorage = () => {
  localStorage.clear();
};

/** Clear only auth-related data (tokens, userInfo). Keeps tenantId, theme, etc. */
const clearAuthData = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userInfo");
  localStorage.removeItem("adminPermissions");
};

const setLocalAdminPermissions = (permissions: unknown[]) => {
  localStorage.setItem("adminPermissions", JSON.stringify(permissions));
};

const getAdminPermissions = (): unknown[] => {
  const raw = localStorage.getItem("adminPermissions");
  if (!raw) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export {
  clearAuthData,
  clearLocalStorage,
  getAccessToken,
  getAdminPermissions,
  getLanguage,
  getRefreshToken,
  getTenantId,
  getTheme,
  getUserInfo,
  setLocalAccessToken,
  setLocalAdminPermissions,
  setLocalLanguage,
  setLocalRefreshToken,
  setLocalTenantId,
  setLocalTheme,
  setLocalUserInfo,
};
